import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import {
  getIsUserInternal,
  getKidTimeoutMs,
  getQuoteIsKidExpected,
  getQuoteIsKidRequired,
  getQuoteRegulationKidDocument,
  getQuoteRegulationKidDocumentError,
  getQuoteRegulationKidDocumentTimeout,
  hasQuoteRegulationKidDocument,
  hasQuoteRegulationKidErrors,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import { KidRegulatoryComponent } from './Regulatory.kid';

export const KidRegulatory: FC<
  PropsWithChildren<{
    tabId: string;
    quoteId: string;
    workspaceType: QuoteWorkspaceType;
  }>
> = ({ tabId, quoteId, workspaceType }) => {
  const isKidExpected = useSelector((state: AppState) => getQuoteIsKidExpected(state, tabId, quoteId));
  const isRequired = useSelector((state: AppState) => getQuoteIsKidRequired(state, workspaceType, tabId));
  const isInternal = useSelector((state: AppState) => getIsUserInternal(state));
  const kidDocument = useSelector((state: AppState) => getQuoteRegulationKidDocument(state, tabId, quoteId));
  const kidDocumentError = useSelector((state: AppState) => getQuoteRegulationKidDocumentError(state, tabId, quoteId));
  const kidDocumentTimeout = useSelector((state: AppState) =>
    getQuoteRegulationKidDocumentTimeout(state, tabId, quoteId),
  );
  const hasKidErrors = useSelector((state: AppState) => hasQuoteRegulationKidErrors(state, tabId, quoteId));
  const isKidLoaded = useSelector((state: AppState) => hasQuoteRegulationKidDocument(state, tabId, quoteId));
  const kidTimeoutMs = getKidTimeoutMs();

  return (
    <KidRegulatoryComponent
      tabId={tabId}
      workspaceType={workspaceType}
      isKidUnavailable={!isKidExpected}
      isKidRequired={isRequired}
      isInternal={isInternal}
      kidTimeoutMs={kidTimeoutMs}
      kidDocument={kidDocument}
      kidDocumentError={kidDocumentError}
      kidDocumentTimeout={kidDocumentTimeout}
      hasKidErrors={hasKidErrors}
      isKidDocumentLoading={!isKidLoaded}
    />
  );
};
